import styled from 'styled-components';
import {theme} from '@styles/theme';

export const ModalWrapper = styled.div`
  width: 432px;
`;

export const ModalContent = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 24px;
  padding: 24px;
  justify-content: center;
  border-top: 1px solid ${theme.colors.basic06};
`;

export const GreyBlockWrapper = styled.div`
  display: flex;
  gap: 8px;
  padding: 8px;
  flex-direction: column;
  background-color: ${theme.colors.basic07};
  border: 0;
  border-radius: ${theme.roundedMedium};
`;

export const CheckboxListBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CheckboxListRow = styled.div`
  padding: 8px 0;
`;
